import { useCallback } from 'react';
import styleBasket from '../components/Baskets/index.module.css';
import styleOptions from '../components/Options/index.module.css';

export const useDragAndDrop = ({ setOptions, setBaskets, setCuttentOptionByClick }) => {
    let currentOption = null;
    let currentOptionBasket = null;
  
    const dragStartHandler = useCallback((e, option, basket) => {
      currentOption = option;
      currentOptionBasket = basket;
    }, [])
  
    const dragEndHandler = useCallback((e) => {
      const target = e.currentTarget;
      if(target.classList.contains(styleBasket.basket)) target.style.border = '2px solid #F2EDF5';
      if(target.classList.contains(styleOptions.optionsWrapper)) target.style.border = '2px solid #F4F4F4';

    }, [])
     
    const dragOvertHandler = useCallback((e) => {
      e.preventDefault();
      
      const target = e.currentTarget;
      if (target.classList.contains(styleBasket.basket) || target.classList.contains(styleOptions.optionsWrapper)) {
          target.style.border = '2px solid rgba(150, 131, 215, 0.7)';
      }
      
    }, [])
  
    const dropHandler = useCallback((e, basket ) => {
      e.preventDefault();
      if (!currentOption || !currentOptionBasket) return;
  
      if(basket === 'none' && currentOptionBasket !== 'none'){ //если переносим в состояние options из какой-то корзины
  
        setOptions((prevOptions) => [...prevOptions, {...currentOption, parrentId: null}])
  
        setBaskets((prevBaskets) => {
          return prevBaskets.map((basket) => {
            if(basket.id == currentOptionBasket.id){
              return {
                ...basket,
                options: basket.options.filter((option) => option.id !== currentOption.id)
              }
            }
            return basket;
          })
        })
  
      }
  
      else if(basket !== 'none' && currentOptionBasket === 'none' && basket){//если переносим в корзину из состояния options
        setOptions((prevOptions) => prevOptions.filter((option) => option.id !== currentOption.id ))
  
        setBaskets((prevBaskets) => {
          return prevBaskets.map((basketIter) => {
            if(basketIter.id == basket.id){
              return {
                ...basketIter,
                options: [...basketIter.options, {...currentOption, parrentId: basket.id}]
              }
            }
            return basketIter;
          })
        })
        
      }
      else if(currentOption !== null && currentOptionBasket.id !== basket.id && currentOptionBasket !== 'none'){
        //если перетаскивание между корзинами
        setBaskets((prevBaskets) => {
          return prevBaskets.map((elem) => {
            if(elem.id == basket.id){
              return {
                ...elem,
                options: [...elem.options, {...currentOption, parrentId: elem.id}]
              }
            }
            if(elem.id == currentOptionBasket.id){
              return {
                ...elem,
                options: elem.options.filter((option) => option.id !== currentOption.id)
              }
            }
            return elem;
          })
        })
      }
      if(e.currentTarget.classList.contains(styleBasket.basket)) e.currentTarget.style.border = '2px solid #F2EDF5';
      if(e.currentTarget.classList.contains(styleOptions.optionsWrapper)) e.currentTarget.style.border = '2px solid #F4F4F4';
      setCuttentOptionByClick(null)
    }, [currentOption, currentOptionBasket])

    return {
        dragStartHandler,
        dragEndHandler,
        dragOvertHandler,
        dropHandler,
    };
};